/**
 * REUSABLE UTILITY MODULE - Constants
 * Can be customized for any project
 */

// ===== STATUS COLORS - Couleurs Zitelou =====
export const STATUS_COLORS = {
  active: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    border: 'border-green-300',
    dot: 'bg-green',
  },
  inactive: {
    bg: 'bg-gray-100',
    text: 'text-gray-800',
    border: 'border-gray-200',
    dot: 'bg-gray-500',
  },
  pending: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    border: 'border-orange-300',
    dot: 'bg-warning',
  },
  suspended: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    border: 'border-orange-300',
    dot: 'bg-warning',
  },
  paused: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    border: 'border-orange-300',
    dot: 'bg-warning',
  },
  cancelled: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    border: 'border-red-300',
    dot: 'bg-danger',
  },
  expired: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    border: 'border-red-300',
    dot: 'bg-danger',
  },
  success: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    border: 'border-green-300',
    dot: 'bg-success',
  },
  error: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    border: 'border-red-300',
    dot: 'bg-danger',
  },
  warning: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    border: 'border-orange-300',
    dot: 'bg-warning',
  },
    trialing: {
        bg: 'bg-orange-100',
        text: 'text-orange-800',
        border: 'border-orange-300',
        dot: 'bg-warning',
    },
  info: {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    border: 'border-blue-300',
    dot: 'bg-primary',
  },
  past_due: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    border: 'border-red-300',
    dot: 'bg-danger',
  },
  none: {
      bg: 'bg-gray-100',
      text: 'text-gray-800',
      border: 'border-gray-200',
      dot: 'bg-gray-500',
  },
};

// ===== STATUS LABELS =====
export const STATUS_LABELS = {
  active: 'Actif',
  inactive: 'Inactif',
  pending: 'En attente',
  suspended: 'Suspendu',
  paused: 'Suspendu',
  cancelled: 'Résilié',
  expired: 'Expiré',
  success: 'Réussi',
  succeeded: 'Réussi',
  error: 'Erreur',
  failed: 'Échoué',
  warning: 'Attention',
  info: 'Information',
  past_due: 'Impayé',
};

// ===== STATUS ICONS (Heroicons) =====
export const STATUS_ICONS = {
  active: 'CheckCircleIcon',
  inactive: 'MinusCircleIcon',
  pending: 'ClockIcon',
  suspended: 'PauseCircleIcon',
  paused: 'PauseCircleIcon',
  cancelled: 'XCircleIcon',
  expired: 'XCircleIcon',
  success: 'CheckCircleIcon',
  error: 'XCircleIcon',
  warning: 'ExclamationTriangleIcon',
  info: 'InformationCircleIcon',
  past_due: 'ExclamationCircleIcon',
};

// ===== PAGINATION =====
export const PAGINATION_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;

// ===== DATE FORMATS =====
export const DATE_FORMATS = {
  short: 'DD/MM/YYYY',
  long: 'DD MMMM YYYY',
  full: 'dddd DD MMMM YYYY',
  time: 'HH:mm',
  datetime: 'DD/MM/YYYY HH:mm',
  iso: 'YYYY-MM-DD',
};

// ===== ROLES =====
export const USER_ROLES = {
  super_admin: {
    label: 'Super Admin',
    color: 'purple',
    permissions: ['all'],
  },
  admin: {
    label: 'Administrateur',
    color: 'blue',
    permissions: ['manage_users', 'manage_subscriptions', 'view_stats', 'manage_config'],
  },
  support: {
    label: 'Support',
    color: 'green',
    permissions: ['view_users', 'view_subscriptions', 'view_stats'],
  },
  viewer: {
    label: 'Lecteur',
    color: 'gray',
    permissions: ['view_stats'],
  },
};

// ===== PERMISSIONS =====
export const PERMISSIONS = {
  // User permissions
  view_users: 'Voir les utilisateurs',
  manage_users: 'Gérer les utilisateurs',
  delete_users: 'Supprimer les utilisateurs',

  // Subscription permissions
  view_subscriptions: 'Voir les abonnements',
  manage_subscriptions: 'Gérer les abonnements',
  cancel_subscriptions: 'Résilier les abonnements',

  // Stats permissions
  view_stats: 'Voir les statistiques',
  export_data: 'Exporter les données',

  // Config permissions
  manage_config: 'Gérer la configuration',
  manage_admins: 'Gérer les administrateurs',
  view_logs: 'Voir les logs',
};

// ===== FILE TYPES =====
export const FILE_TYPES = {
  images: {
    label: 'Images',
    accept: 'image/*',
    mimes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'],
    maxSize: 5, // MB
  },
  documents: {
    label: 'Documents',
    accept: '.pdf,.doc,.docx,.xls,.xlsx,.txt',
    mimes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/plain',
    ],
    maxSize: 10, // MB
  },
  csv: {
    label: 'CSV',
    accept: '.csv',
    mimes: ['text/csv', 'application/vnd.ms-excel'],
    maxSize: 5, // MB
  },
};

// ===== TOAST DURATION =====
export const TOAST_DURATION = {
  short: 2000,
  medium: 3000,
  long: 5000,
};

// ===== API RESPONSE STATUS =====
export const API_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading',
  IDLE: 'idle',
};

// ===== HTTP STATUS CODES =====
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

// ===== CHART COLORS =====
export const CHART_COLORS = [
  '#3B82F6', // blue-500
  '#10B981', // green-500
  '#F59E0B', // yellow-500
  '#EF4444', // red-500
  '#8B5CF6', // purple-500
  '#EC4899', // pink-500
  '#06B6D4', // cyan-500
  '#F97316', // orange-500
];

// ===== BREAKPOINTS (matching Tailwind) =====
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

// ===== KEYBOARD KEYS =====
export const KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  TAB: 'Tab',
  SPACE: ' ',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
};

// ===== ANIMATION DURATIONS =====
export const ANIMATION_DURATION = {
  fast: 150,
  normal: 300,
  slow: 500,
};

// ===== Z-INDEX LEVELS =====
export const Z_INDEX = {
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modalBackdrop: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070,
};

// ===== REGEX PATTERNS =====
export const PATTERNS = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/,
  url: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/,
  postalCode: /^[0-9]{5}$/,
  alphanumeric: /^[a-zA-Z0-9]+$/,
  alphabetic: /^[a-zA-ZÀ-ÿ\s]+$/,
  numeric: /^[0-9]+$/,
  slug: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
};

// ===== CURRENCIES =====
export const CURRENCIES = {
  EUR: { symbol: '€', name: 'Euro', locale: 'fr-FR' },
  USD: { symbol: '$', name: 'US Dollar', locale: 'en-US' },
  GBP: { symbol: '£', name: 'British Pound', locale: 'en-GB' },
  CHF: { symbol: 'CHF', name: 'Swiss Franc', locale: 'fr-CH' },
};

// ===== COUNTRIES (French context) =====
export const COUNTRIES = {
  FR: { name: 'France', code: 'FR', flag: '🇫🇷' },
  BE: { name: 'Belgique', code: 'BE', flag: '🇧🇪' },
  CH: { name: 'Suisse', code: 'CH', flag: '🇨🇭' },
  CA: { name: 'Canada', code: 'CA', flag: '🇨🇦' },
  LU: { name: 'Luxembourg', code: 'LU', flag: '🇱🇺' },
};

// ===== TIME ZONES =====
export const TIMEZONES = {
  'Europe/Paris': 'Paris (UTC+1)',
  'Europe/Brussels': 'Bruxelles (UTC+1)',
  'Europe/Zurich': 'Zurich (UTC+1)',
  'America/Montreal': 'Montréal (UTC-5)',
};

// ===== EXPORT FORMATS =====
export const EXPORT_FORMATS = {
  CSV: { label: 'CSV', extension: 'csv', mime: 'text/csv' },
  JSON: { label: 'JSON', extension: 'json', mime: 'application/json' },
  EXCEL: { label: 'Excel', extension: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  PDF: { label: 'PDF', extension: 'pdf', mime: 'application/pdf' },
};

// ===== TABLE SORT ORDERS =====
export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

// ===== ERROR MESSAGES (reusable) =====
export const ERROR_MESSAGES = {
  REQUIRED: 'Ce champ est requis',
  INVALID_EMAIL: 'Adresse email invalide',
  INVALID_PHONE: 'Numéro de téléphone invalide',
  INVALID_URL: 'URL invalide',
  INVALID_DATE: 'Date invalide',
  MIN_LENGTH: (min) => `Minimum ${min} caractères requis`,
  MAX_LENGTH: (max) => `Maximum ${max} caractères autorisés`,
  MIN_VALUE: (min) => `La valeur minimum est ${min}`,
  MAX_VALUE: (max) => `La valeur maximum est ${max}`,
  PASSWORDS_DONT_MATCH: 'Les mots de passe ne correspondent pas',
  WEAK_PASSWORD: 'Le mot de passe est trop faible',
  FILE_TOO_LARGE: (max) => `Le fichier est trop volumineux (max: ${max}MB)`,
  INVALID_FILE_TYPE: 'Type de fichier non autorisé',
  NETWORK_ERROR: 'Erreur de connexion au serveur',
  UNAUTHORIZED: 'Non autorisé. Veuillez vous reconnecter.',
  FORBIDDEN: 'Accès refusé',
  NOT_FOUND: 'Ressource non trouvée',
  SERVER_ERROR: 'Erreur serveur. Veuillez réessayer.',
  UNKNOWN_ERROR: 'Une erreur est survenue',
};

// ===== SUCCESS MESSAGES (reusable) =====
export const SUCCESS_MESSAGES = {
  SAVED: 'Enregistré avec succès',
  CREATED: 'Créé avec succès',
  UPDATED: 'Mis à jour avec succès',
  DELETED: 'Supprimé avec succès',
  COPIED: 'Copié dans le presse-papiers',
  EXPORTED: 'Données exportées avec succès',
  EMAIL_SENT: 'Email envoyé avec succès',
  PASSWORD_CHANGED: 'Mot de passe modifié avec succès',
  LOGIN_SUCCESS: 'Connexion réussie',
  LOGOUT_SUCCESS: 'Déconnexion réussie',
};

const constantsExport = {
  STATUS_COLORS,
  STATUS_LABELS,
  STATUS_ICONS,
  PAGINATION_OPTIONS,
  DEFAULT_PAGE_SIZE,
  DATE_FORMATS,
  USER_ROLES,
  PERMISSIONS,
  FILE_TYPES,
  TOAST_DURATION,
  API_STATUS,
  HTTP_STATUS,
  CHART_COLORS,
  BREAKPOINTS,
  KEYS,
  ANIMATION_DURATION,
  Z_INDEX,
  PATTERNS,
  CURRENCIES,
  COUNTRIES,
  TIMEZONES,
  EXPORT_FORMATS,
  SORT_ORDER,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
};

export default constantsExport;
